import { format, parse } from 'date-fns';

export const today = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
};

export const formatDateCalendar = (date: Date) => {
  return format(date, 'dd.MM.yyyy');
};

export const formatMonthCalendar = (date: Date) => {
  return format(date, 'MMMM yyyy');
};

export const formatMonthWeek = (date: Date) => {
  return format(date, "'W'ww - MMMM yyyy");
};

export const formatDayCalendar = (date: Date) => {
  return format(date, 'd');
};

export const formatDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const formatDateLocale = (date: Date) => {
  return format(date, 'EEE dd.MM.yyyy');
};

export const formatWeekday = (date: Date) => {
  return format(date, 'EEEE');
};

export const parseDate = (dateString: string) => {
  return parse(dateString, 'yyyy-MM-dd', today());
};

export const parseApiDate = (dateString: string) => {
  const utcString = dateString.replace(' ', 'T') + 'Z';
  return parse(utcString, "yyyy-MM-dd'T'HH:mm:ssX", today());
};

export const formatTime = (date: Date) => {
  return format(date, 'HH:mm');
};

export const formatDateTime = (date: Date) => {
  return format(date, 'yyyy-MM-dd HH:mm:ss');
};

export const SATURDAY = 6;
export const SUNDAY = 0;
